export default {
  home_about: {
    badge: 'About AllChinaBuy Sheet',
    title: 'Your Ultimate\nShopping Companion',
    p1: 'The AllChinaBuy spreadsheet has become an essential tool for thousands of savvy shoppers worldwide. Whether you are hunting for the latest sneaker releases, premium streetwear pieces, or hidden luxury gems, having a well-organized spreadsheet saves hours of browsing.',
    p2: 'Our AllChinaBuy spreadsheet 2026 directory brings together the most comprehensive collection of verified finds — from shoes and hoodies to bags, accessories, and everything in between. Each entry is regularly updated so you always get the freshest picks.',
    p3: 'What sets our directory apart is the level of curation. Every entry is manually reviewed for accuracy and relevance. This means you spend less time digging through dead links and more time finding exactly what you want.',
    cta1: 'Visit Main Store',
    cta2: 'Read Full Guide',
  },
  home_trust: {
    badge: 'Why Choose Us',
    title: 'Trusted by Thousands of Shoppers',
    subtitle: 'Our AllChinaBuy spreadsheet directory is built on reliability, freshness, and real user feedback — here is what makes it the go-to resource for smart shoppers in 2026.',
    t1: 'Updated Weekly',
    t1d: 'Our directory is refreshed every week with the latest finds, ensuring you never miss a new drop or trending item across all 14 categories.',
    t2: 'Quality Verified',
    t2d: 'Every spreadsheet undergoes manual review before listing. We check for dead links, outdated pricing, and inaccurate product descriptions.',
    t3: 'Organized Categories',
    t3d: 'Browse through 14 carefully organized categories — from sneakers and hoodies to accessories and fragrances — to find exactly what you need in seconds.',
    t4: 'Fast Navigation',
    t4d: 'Direct links to verified product listings eliminate guesswork and get you from browsing to buying faster than ever before.',
    t5: 'Comparison Guides',
    t5d: 'Side-by-side comparisons help you evaluate different AllChinaBuy spreadsheet options, pricing tiers, and agent recommendations before committing.',
    t6: 'Latest Finds',
    t6d: 'Stay ahead of trends with early access to newly discovered gems, limited releases, and under-the-radar bargains across all categories.',
  },
  home_articles: {
    badge: 'Latest Guides',
    title: 'Expert Articles & Resources',
    subtitle: 'Dive deeper into the world of AllChinaBuy spreadsheets with in-depth guides, comparison articles, and expert tips designed to help you shop smarter.',
    more: 'More guides coming soon — bookmark this page and check back weekly for new content.',
  },
  home_faq: {
    badge: 'FAQ',
    title: 'Frequently Asked Questions',
    subtitle: 'Everything you need to know about AllChinaBuy spreadsheets, how they work, and how to get the most out of our directory.',
    q1: 'What is an AllChinaBuy spreadsheet?',
    a1: 'A AllChinaBuy spreadsheet is a curated list of product links organized in a spreadsheet format, typically shared within the rep and streetwear community. These spreadsheets contain direct links to items available on platforms like Taobao, Weidian, and 1688 that can be purchased through the AllChinaBuy agent service.',
    q2: 'How often are the spreadsheets updated?',
    a2: 'Our directory is updated on a weekly basis. Every week our team reviews new submissions, verifies existing links, and adds fresh finds across all 14 categories.',
    q3: 'How do I use a spreadsheet to place an order?',
    a3: 'Browse our directory and find a category or product you want. Click through to the main store where you will find the complete spreadsheet with product links. Copy the link, paste it into your AllChinaBuy agent search bar, and the agent handles the purchasing process.',
    q4: 'Are these spreadsheets free to access?',
    a4: 'Yes, all spreadsheets listed in our directory are completely free to access and use. You only pay for the items you choose to purchase along with standard agent fees and shipping costs.',
    q5: 'How do you verify the quality of products in the spreadsheets?',
    a5: 'Our verification process involves checking seller ratings, reviewing community feedback and QC photos, and monitoring return rates. Only spreadsheets with consistently positive feedback make it into our directory.',
    q6: 'Can I submit my own spreadsheet to be listed?',
    a6: 'We welcome community contributions. If you have created a quality spreadsheet you would like to share, reach out through our main store contact page. Our team will review your submission for accuracy and quality.',
  },
  home_cta: {
    title: "Ready to Find Your\nNext Great Deal?",
    subtitle: 'Join thousands of smart shoppers already using our AllChinaBuy spreadsheet directory. Updated weekly with the latest verified finds across 14 categories.',
    cta1: 'Browse Spreadsheets',
    cta2: 'Read the Guide',
  },
  home: {
    metaTitle: 'AllChinaBuy Spreadsheet — Find Products, Check QC & Shop Smarter',
    metaDescription:
      'Explore the AllChinaBuy spreadsheet to discover product finds, compare categories, learn QC and understand shipping costs. Independent buying guides in one place.',
    hero: {
      badge: 'Independent buying guide',
      title: 'AllChinaBuy Spreadsheet — Find Products, Check QC & Shop Smarter',
      subtitle:
        'Explore the AllChinaBuy spreadsheet, discover product finds, compare categories, learn QC, understand shipping costs and follow practical buying guides in one place.',
    },
    what: {
      title: 'What Is the AllChinaBuy Spreadsheet?',
      p1: 'An AllChinaBuy spreadsheet is a shareable, organized list of product finds — links, QC photos, seller notes and shipping hints — that helps you browse and buy with more confidence. Instead of scrolling through endless store pages, you open one tidy table and jump straight to items that fit your style and budget.',
      p2: 'The real value is in the filtering. Good spreadsheets are sorted by category, mark whether an item has already been reviewed, and include real QC photos so you can skip the guesswork and avoid common mistakes.',
      p1Title: 'Curated, not random',
      p2Title: 'Built to save you time',
    },
    categories: {
      title: 'Browse Categories',
      subtitle: 'Pick a category to explore curated product finds.',
      placeholder: 'Choose a category...',
      go: 'Go to category',
      viewAll: 'View all categories',
    },
    articles: {
      title: 'Buying Guides & Pillar Articles',
      subtitle: 'Original, independent guides on AllChinaBuy reviews, shipping, QC, coupons, safety and more.',
      readMore: 'Read article',
    },
    guide: {
      title: 'Latest Spreadsheet Guide',
      subtitle:
        'New to the spreadsheet? Start with our complete guide covering product finds, QC and smart shopping.',
      cardTitle: 'AllChinaBuy Spreadsheet: Complete Guide',
      cardText:
        'Learn how the spreadsheet works, how to use it step by step, and what to watch for before you check out.',
      read: 'Read the Guide',
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'What is an AllChinaBuy spreadsheet?',
      a1: 'It is a shareable, organized list of product finds with links, QC photos and notes that helps you browse and buy with more confidence.',
      q2: 'Is this an official AllChinaBuy website?',
      a2: 'No. This is an independent information resource and is not affiliated with or endorsed by AllChinaBuy.',
      q3: 'Do I need the spreadsheet to shop?',
      a3: 'No, but it saves a lot of time by giving you curated links and real QC photos you would otherwise have to find yourself.',
      q4: 'How much does shipping cost?',
      a4: 'It varies by weight, size and shipping line. Light items cost less, and consolidating parcels usually reduces the total.',
    },
    finalCta: {
      title: 'Ready to Find Your Next Product?',
      text: 'Browse the curated categories and start your next order with more confidence.',
    },
  },
};